import Vue from "vue";
import commonService from "@/common/api-services/common";
let mobileBaseUrl = `${process.env.VUE_APP_CONFIG_MOBILE_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let headers = {
	headers: {
		"Content-Type": "application/json",
		"x-api-key": apikey,
	},
};

const mobileDashboardService = {

	/**  NOTE: this is only for new carriers, needs to be tested for all  **/
	async insertSimData(item) {
		let iccid = item.ICCID,
			pin1 = item.pin1,
			pin2 = item.pin2,
			puk2 = item.puk2,
			kid = item.puk2,
			operator = item.Operator,
			ki = item.Ki,
			imsi = item.Imsi,
			opc = item.Opc,
			msisdn = item.MSISDN,
			customer = item.Customer,
			status = item.Status,
			product = item.Product;
		let url = `${mobileBaseUrl}?method=IOT_InsertSimData&iccid=${iccid}&pin1=${pin1}&pin2=${pin2}&puk2=${puk2}&kid=${kid}&operator=${operator}&ki=${ki}&imsi=${imsi}&opc=${opc}&msisdn=${msisdn}&customer=${customer}&status=${status}&product=${product}`;
		return Vue.axios.get(url, headers);
	},

	/** NOTE: The below methods are for IOT/MNSHUB/INLAND only **/
	async simple_activate(imsi, msisdn, product, simtype, data=1) {
		let params = `IOT_Activate&imsi=${imsi}&msisdn=${msisdn}&product=${product}&simtype=${simtype}&data=${data}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_terminate(imsi, return_stock='KeepProperties') {
		let params = `IOT_Terminate&imsi=${imsi}&return_stock=${return_stock}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_suspend(imsi) {
		let params = `IOT_Suspend&imsi=${imsi}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_resume(imsi) {
		let params = `IOT_Resume&imsi=${imsi}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_getstate(imsi) {
		let params = `IOT_GetState&imsi=${imsi}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_getsubscriber(imsi) {
		let params = `LookupSubscriber&imsi=${imsi}`;
		return commonService.commonAPI(params, 0, 15);
	},
	async simple_getimsifromiccid(iccid) {
		let params = `IOT_GetImsiFromIccid&iccid=${iccid}`;
		return commonService.commonAPI(params, 0, 15);
	},

	/** NOTE: The above methods are for IOT/MNSHUB/INLAND only **/

};

export default mobileDashboardService;
